import styled from 'styled-components'

export const Content = styled.div`
  display: block;
  max-width: 100vw;
  overflow: hidden;
  height: 60px;
  margin-top: 10px;
  margin-bottom: 5px;
`
